exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".promo-cards {\n  color: #fff; }\n\n.card-header {\n  font-size: 66px;\n  text-align: left;\n  margin-bottom: -76px; }\n\n.content h5 {\n  padding-top: 5px;\n  padding-bottom: 5px;\n  border-bottom: 1px solid #e2e2e2; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/PROJECTS/Sokousoni/winda-dashboard/dashboard-winda-mvp/src/app/promocodes/promocodes.component.scss
// module id = ../../../../../src/app/promocodes/promocodes.component.scss
// module chunks = main